module.exports = __webpack_public_path__ + "static/img/finolex.a469ef3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/finolex.png
// module id = +T65
// module chunks = 1